var map = {
	"./img_1.jpg": 70901,
	"./img_2.jpg": 79364,
	"./img_3.jpg": 26352,
	"./img_4.jpg": 84457,
	"./img_5.jpg": 26714,
	"./img_6.png": 69873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8184;